import { render, staticRenderFns } from "./Customs.vue?vue&type=template&id=dc6de266"
import script from "./Customs.vue?vue&type=script&lang=ts"
export * from "./Customs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports